module.exports = __webpack_public_path__ + "static/media/Type2Icon.3743a596.png";